import type { PDFDocumentProxy } from "pdfjs-dist";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type PdfFileData = {
  data: string | File;
  name: string;
};

interface DocumentState {
  pdfFile: PdfFileData | null;
  pdfDocument: PDFDocumentProxy | null;
  currentPage: number;
  totalPages: number;
  isDocumentLoaded: boolean;
  pdfError: string | null;
  fileSize: number;

  // 액션들
  setPdfFile: (file: { data: string | File; name: string } | null) => void;
  setPdfDocument: (doc: PDFDocumentProxy | null) => void;
  setCurrentPage: (page: number) => void;
  setTotalPages: (pages: number) => void;
  setIsDocumentLoaded: (loaded: boolean) => void;
  setPdfError: (error: string | null) => void;
  setFileSize: (size: number) => void;
  resetPdfState: () => void;
}

export const useDocumentStore = create<DocumentState>()(
  persist(
    (set) => ({
      pdfFile: null,
      pdfDocument: null,
      currentPage: 1,
      totalPages: 0,
      isDocumentLoaded: false,
      pdfError: null,
      fileSize: 0,

      setPdfFile: (file) => set({ pdfFile: file }),
      setPdfDocument: (doc) => set({ pdfDocument: doc }),
      setCurrentPage: (page) => set({ currentPage: page }),
      setTotalPages: (pages) => set({ totalPages: pages }),
      setIsDocumentLoaded: (loaded) => set({ isDocumentLoaded: loaded }),
      setPdfError: (error) => set({ pdfError: error }),
      setFileSize: (size) => set({ fileSize: size }),
      resetPdfState: () =>
        set({
          pdfFile: null,
          pdfDocument: null,
          currentPage: 1,
          totalPages: 0,
          isDocumentLoaded: false,
          pdfError: null,
          fileSize: 0,
        }),
    }),
    {
      name: "pdf-document-storage",
      partialize: (state) => ({
        pdfFile: state.pdfFile,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        fileSize: state.fileSize,
      }),
    }
  )
);
